import React from 'react'
import Dev from '../Components/Developers/Dev'
import Footer from '../Components/Footer/Footer'
import Navbar from '../Components/Navbar/Navbar'

function Devteam() {
    return (
        <div>
            <Navbar/>
            <Dev/>
            <Footer/>
        </div>
    )
}

export default Devteam
